import { FC } from 'react'
import type { IconProps } from '../../types'

// prettier-ignore
const NotificationWarningIcon: FC<IconProps> = ({ size = 20, color = '#CC7400' }) => (
  <svg width={size} height={size} viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_3720_318114)'>
      <circle cx='10.0001' cy='10' r='10' fill={color} />
      <path d='M10.0001 5V11' stroke='white' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M10.0001 15V15.01' stroke='white' strokeWidth='3' strokeLinecap='round' strokeLinejoin='round' />
    </g>
    <defs>
      <clipPath id='clip0_3720_318114'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export default NotificationWarningIcon
